import { render, staticRenderFns } from "./ReferralOverviewPage.vue?vue&type=template&id=5bfdd50a"
import script from "./ReferralOverviewPage.vue?vue&type=script&lang=js"
export * from "./ReferralOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralOverviewPage.vue?vue&type=style&index=0&id=5bfdd50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports